<a
  class="article-tag nordic-blue-900-text nordic-blue-50-bg ps-xsmall-y ps-small-x rounded-border inline-block font-body-1 no-underline nordic-blue-900-border border light-type ms-small-r"
  [finLink]="tagUrl"
  >{{ tagTitle }}</a
>
